/** QuickPlan — Barre d'état : message courant, sélection, raccourcis. */
import { useProjectStore } from '../store/useProjectStore.js';

export default function StatusBar() {
  const statusText = useProjectStore((s) => s.statusText);
  const selection = useProjectStore((s) => s.selection);
  const me = useProjectStore((s) => s.me);
  return (
    <div className="statusbar">
      <span className="grow">{statusText}</span>
      {selection.length > 0 && <span>{selection.length} sélectionné{selection.length > 1 ? 's' : ''}</span>}
      <span className="keys">G déplacer · R tourner · Maj+glisser zone · H masquer · O ouvrir · F cadrer · 1-4 vues · Ctrl+D · Suppr</span>
      {me?.version && <span className="ver">v{me.version}</span>}
    </div>
  );
}
